export default {
  club_name: 'Beyond Skiing',
  club_name_short: 'beyondskiing',
  stadium_name: '',
  staging_url: 'https://beyondskiing.api.fangroup.io',
  prod_url: 'https://beyondskiing.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/beyondskiing',
  club_logo: '/assets/teams/beyondskiing.png',
  app_name: 'beyondskiing',
  websale_name: 'beyondskiing',
  ntb_team_id: 10063,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'beyondskiing',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
